export const hasActiveListFilter = (value: string | null | undefined) =>
  value !== null && value !== undefined && value !== '';

export const hasActiveMultiFilter = (values: readonly string[] | null | undefined) =>
  Array.isArray(values) && values.length > 0;

export const hasActiveSelectFilter = (value: string, allValue = 'all') =>
  value !== allValue && value !== '';
